import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import AuthGate from './components/AuthGate.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthGate>{(user, signOut) => <App key={user.id} authUser={user} onSignOut={signOut} />}</AuthGate>
  </StrictMode>,
)
